import getUrls from './getUrls';
import routerUtility from 'utils/routerUtility';
import ModuleAccessCodes from 'constants/moduleCodes';
import { ToBuildAProfileLoader } from './loader';
import { ReportsRouterHelper } from './helper/routerHelpers/reportsRouterHelper';
import { LearnerPortfolioRouterHelper } from './helper/routerHelpers/learnerPortfolioRouterHelper';
import { GeneralRouterHelper } from './helper/routerHelpers/generalRouterHelper';
import { ObservationsRouterHelper } from './helper/routerHelpers/observationsRouterHelper';
import { ParentShareRouterHelper } from './helper/routerHelpers/parentShareRouterHelper';
import { AssessmentRouterHelper } from './helper/routerHelpers/assessmentRouterHelper';
import { isExternalModuleRoute } from '../../../helper/ExternalModuleHelper';
import { handleLazyLoadError } from '../../../helper/error-helper';

export default {

  path: getUrls.getModuleUrl(),

  getIndexRoute(partialNextState, callback) {
    require.ensure([], function (require) {
      callback(null, {
        component: require('./views/home/homePage').default,
      }, '2bap-home');
    })
  },

  getComponent(nextState, callback) {
    const error = routerUtility.getAccessError(ModuleAccessCodes.MODULE_2BAP);
    if (error === null) {
      ToBuildAProfileLoader.load(callback).catch(handleLazyLoadError);
    } else {
      callback(error);
    }
  },

  getChildRoutes(partialNextState, callback) {
    const isExternalModule = isExternalModuleRoute(partialNextState);
    if (isExternalModule) {
      callback();
      return;
    }

    require.ensure([], function (require) {
      callback(null, [
        {
          path: ReportsRouterHelper.REPORTS_BASE_URL,
          component: require('./layouts/ReportsPageLayout').ReportsPageLayout,
          childRoutes: [
            {
              path: ReportsRouterHelper.REPORTS_LIST_URL,
              component: require('./views/reports/reportsList/ReportsListPage').ReportsListPage
            },
            {
              path: ReportsRouterHelper.REPORTS_GENERATION_URL,
              component: require('./views/reports/reportsGeneration/ReportsGenerationPage').ReportsGenerationPage,
              onEnter: ReportsRouterHelper.handleReportGenerationRouteEnter
            }
            ]
        },
        {
          path: LearnerPortfolioRouterHelper.LEARNER_PORTFOLIO_LIST_PATH,
          async getComponent() {
            window._ = (await import('lodash')).default;
            const module = await import('./views/learnersPortfolio/LearnersPortfoliosPage');
            return module.LearnersPortfoliosPage;
          }
        },
        {
          path: `${LearnerPortfolioRouterHelper.LEARNER_PORTFOLIO_LIST_PATH}/:${LearnerPortfolioRouterHelper.LEARNER_PORTFOLIO_IDENTIFIER}`,
          component: require('./views/learnersPortfolio/LearnerPortfolioPage').LearnerPortfolioPage
        },
        {
          path: `${ObservationsRouterHelper.OBSERVATION_DETAILS_PATH}/:${ObservationsRouterHelper.OBSERVATION_IDENTIFIER}`,
          component: require('./views/observationsDetails/ObservationsDetailsPage').ObservationsDetailsPage
        },
        {
          path: AssessmentRouterHelper.ASSESSMENTS_PATH,
          component: require('./layouts/AssessmentPageLayout').AssessmentPageLayout
        },
        {
          path: ParentShareRouterHelper.PARENT_SHARE_PATH,
          component: require('./views/parentShare/ParentSharePage').ParentSharePage
        },
        {
          path: GeneralRouterHelper.MY_PROFILE_PATH,
          component: require('../../../component/profile/profilePage')
        },
        {
          path: GeneralRouterHelper.NOT_FOUND_PATH,
          component: require('../../../component/errors/notFoundPage')
        }
      ])
    },
    handleLazyLoadError,
    '2bap'
    );
  }

};
